import React from "react"
import {serverSideTranslations} from "next-i18next/serverSideTranslations"
import NavBar from "../components/navigation/NavBar"
import {useTranslation} from "next-i18next"
import nextI18NextConfig from "../next-i18next.config.js"
import MbpHead from "../components/head/MbpHead"
import FooterCheckout from "../components/footer/FooterCheckout"
import {CheckoutContainerPage1} from "../components/checkout"
import {getPageData} from "../pageData"
import {getDeals} from "../hubspot/getDeals"
import DiscountCodeContextProvider from "../provider/DiscountCodeContextProvider"

const Checkout = () => {
	const {t} = useTranslation("common")
	return (
		<>
			<MbpHead>
				<title>{`${t("Checkout")} | MyBikePlan`}</title>
			</MbpHead>
			<NavBar />
			<DiscountCodeContextProvider>
				<CheckoutContainerPage1 />
			</DiscountCodeContextProvider>
			<FooterCheckout/>
		</>
	)
}

export async function getStaticProps({locale, query}) {
	return {
		props: {
			...(await getPageData(locale, [])),
			deals: await getDeals(),
			...(await serverSideTranslations(locale, ["common", "checkout", "homeDetails", "search", "warningcart", "insurance", "sponsorship"], nextI18NextConfig))
		}
	}
}

export default Checkout
